module.exports = __webpack_public_path__ + "img/edit.6a211add.svg";